import ImageZoom from "../../commons/ImageZoom";

const Treeosk = () => {
  return (
    <div className="portfolio">
      <header className="portfolio-header">
        <p className="portfolio-kicker">Produit SaaS</p>
        <h1>Créateur d&apos;interfaces Treeosk</h1>
        <p>
          Treeosk transforme l’expérience en magasin grâce à des supports
          digitaux interactifs. Maintenance et évolution du créateur
          d’interfaces.
        </p>
      </header>

      <section className="project-gallery">
        <div className="project">
          <ImageZoom alt="Interface d'administration Treeosk" src="./assets/treeosk-admin.png" />
          <h3>Ajout de composants</h3>
          <p>
            Nouveaux composants et modules pour enrichir le catalogue
            d’interfaces Treeosk.
          </p>
        </div>
        <div className="project">
          <ImageZoom alt="Connexion distante aux écrans" src="./assets/treeosk-connect.png" />
          <h3>Websocket à distance</h3>
          <p>
            Mise à jour des interfaces d’écrans à distance pour limiter les
            déplacements des techniciens.
          </p>
        </div>
      </section>

      <section className="skills">
        <h2>Technologies utilisées</h2>
        <ul>
          <li>JavaScript</li>
          <li>React</li>
          <li>CSS / SCSS</li>
          <li>Node.js</li>
          <li>Express</li>
          <li>GraphQL</li>
          <li>PostgreSQL</li>
        </ul>
      </section>

      <footer className="portfolio-footer">
        <a href="mailto:julien.j.1999@hotmail.com">
          Contactez-moi : julien.j.1999@hotmail.com
        </a>
      </footer>
    </div>
  );
};

export default Treeosk;
